const safeJsonParse = (value, fallback = []) => {
	try {
		return value ? JSON.parse(value) : fallback;
	} catch {
		return fallback;
	}
};

export { safeJsonParse };
